// Add to cart button script
jQuery(document).ready(function(){
	jQuery("#quantity-0").focus();    
	jQuery("#submit-table").click(function(e) {     
		e.preventDefault();
		//array for Variant Titles
		var toAdd = new Array();
        var qty ;
		for(i=0; i < wholesalelistlen; i++){
        	var count =	jQuery("#quantity-"+i).val() || 0;
          if(count){
          	toAdd.push({
				variant_id: jQuery("#variant-"+i).val(),        
				quantity_id: count
			});
          }

		}
		function moveAlong(){
			if (toAdd.length) {
				var request = toAdd.shift();
				var tempId= request.variant_id;
				var tempQty = request.quantity_id;
				var params = {
					type: 'POST',
					url: '/cart/add.js',
					data: 'quantity='+tempQty+'&id='+tempId,
					dataType: 'json',
					success: function(line_item) { 
						//console.log("success!");
						moveAlong();

					},
					error: function() {
						//console.log("fail");
						moveAlong();

					}
				};
				jQuery.ajax(params);
			}
			else {				
				document.location.href = '/cart';
			}  
		};
		moveAlong();
	});
});

//JS funtions to read/write cookies
function setCookie(cname, cvalue, exhours) {
    var d = new Date();
    d.setTime(d.getTime() + (exhours*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

jQuery(document).ready(function(){

//login to wholesale order form
jQuery('[name=password]').focus();  

showOrderForm = function(){
	var savedPassword = getCookie("whtoken");
   	if (savedPassword == password) {
      	jQuery('#mainForm').show(); 
        jQuery('#passwordForm').hide();           
   	}
    return false;
}

showOrderForm();    

tryPassword = function(){
	var inputPassword = jQuery('[name=password]').val();    
    if (inputPassword == password) {
    	setCookie("whtoken", password, 2);
		showOrderForm();   
	} else {
		jQuery('#wrongPassword').show();
      	jQuery('[name=password]').val('');
      	jQuery('[name=password]').focus();
	}        
	return false;
}

//logout from wholesale order form
logoutWholesale = function(){
	setCookie("whtoken", '', 1);
	jQuery('#mainForm').hide();
  	jQuery('#passwordForm').show();
  	jQuery('[name=password]').val('');
    jQuery('[name=password]').focus();
  	return false;
}           

//update price and qty field on product select
jQuery('.product-select').each(function () {
	jQuery(this).change(function () {
		var selectedID = jQuery(this).attr('id');
		var selectedValue = jQuery(this).val();
		var selectedText = jQuery('#'+selectedID+' option:selected').text();
		var selectedPrice = selectedText.split(' - ');
		jQuery("#variant-"+selectedID).val(selectedValue);
		jQuery("#price-"+selectedID).html(selectedPrice[1]);
	});
});

//put some listeners on quantity fields
jQuery('.prodQuantity input[type=number]').on('blur keyup click',function() {
	updateCartButton();    
});        

//calculate add to cart button
updateCartButton = function(){
	var count = 0;
	jQuery('.prodQuantity input[type=number]').each(function(){
		var thisCount = +jQuery(this).val() || 0;
		count += thisCount;
	});
    console.log(count);
	if(count > 0){
		jQuery('#submit-float,#submit-table').attr('value','ADD '+count+' TO CART');
		jQuery('#submit-float').fadeIn();
	} else {
        jQuery('#submit-float,#submit-table').attr('value','ADD TO CART');
		jQuery('#submit-float').hide();
	}
};

//hide the float button when it shows below big submit
jQuery(window).on('scroll resize',function() {
	var floatTop = jQuery('#submit-float').offset().top + 80;
    var submitTop = jQuery('#submit-table').offset().top;
    if(floatTop > submitTop){
       	jQuery('#submit-float').css({opacity:0});
    } else {
   	   	jQuery('#submit-float').css({opacity:1});
    }
});

updateCartButton();

//live search 
jQuery("#prodSearch").on("keyup", function() {
	var value = $(this).val().toLowerCase();
    jQuery("#prodTable tr").filter(function() {
    	jQuery(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

//product image light box
jQuery(".lightbox-trigger").click(function(event){
	event.preventDefault();
	var imgSrc = jQuery(this).parent().attr("href");
	jQuery(".popup-box .img-wrap img").attr("src", imgSrc);
	jQuery(".backdrop, .popup-box").animate({ opacity: ".50" }, 300, "linear");
	jQuery(".popup-box").animate({ opacity: "1.00" }, 300, "linear");
	jQuery(".backdrop, .popup-box").css("display", "block");
});
function close_box(){
	jQuery(".backdrop, .popup-box").animate({ opacity: "0" }, 300, "linear", function(){
		jQuery(".backdrop, .popup-box").css("display", "none");
	});
}  
jQuery(".close").click(function(){
	close_box();
});
jQuery(".backdrop").click(function(){
	close_box();
});

});